import OvhAtInternet from '@ovh-ux/ovh-at-internet';
import { CUSTOM_VARIABLES } from './config.constants.js';
const getCookie = (cookieId) => {
    const latestCookies = document === null || document === void 0 ? void 0 : document.cookie;
    const idCookie = latestCookies === null || latestCookies === void 0 ? void 0 : latestCookies.split(';').find((item) => item.includes(cookieId));
    if (idCookie) {
        return idCookie.split('=')[1];
    }
    return '';
};
export class TrackingPlugin extends OvhAtInternet {
    setConfig(region, config) {
        this.config = config;
        this.configureTracking(region, this.currentUser);
    }
    waitForConfig(retryInterval = 500) {
        return new Promise((resolve) => {
            const checkConfig = () => {
                if (this.config) {
                    resolve(this.config);
                }
                else {
                    setTimeout(checkConfig, retryInterval);
                }
            };
            checkConfig();
        });
    }
    getConfigByRegion(region) {
        return Object.assign({}, (this.config[region] && this.config[region].config));
    }
    configureTracking(region, user, locale) {
        this.currentUser = user;
        const referrerSite = getCookie('OrderCloud');
        const data = Object.assign(Object.assign(Object.assign({}, CUSTOM_VARIABLES), (this.config ? this.getConfigByRegion(region) : {})), (referrerSite ? { referrerSite } : {}));
        const interfaceLanguage = locale || this.defaults.interfaceLanguage;
        const defaultConfig = Object.assign(Object.assign(Object.assign({}, data), { countryCode: user === null || user === void 0 ? void 0 : user.country, currencyCode: (user === null || user === void 0 ? void 0 : user.currency) && (user === null || user === void 0 ? void 0 : user.currency.code), visitorId: user === null || user === void 0 ? void 0 : user.customerCode, legalform: user === null || user === void 0 ? void 0 : user.legalform, subsidiary: user === null || user === void 0 ? void 0 : user.ovhSubsidiary, language: user === null || user === void 0 ? void 0 : user.language }), { interfaceLanguage });
        this.setDefaults(defaultConfig);
        this.setRegion(region);
    }
}
//# sourceMappingURL=tracking.js.map